import {ArrivaBabboNataleView} from "./arriva-babbo-natale.view";
export default ArrivaBabboNataleView;
